import { corePayeePromotionalCampaignClient } from 'app/api/apiClient/generated/corePayeePromotionalCampaignClient';
import { useCanViewPayeePromotionalCampaigns } from 'app/api/hooks/core/v1/auth/user';
import { queries } from 'app/constants/queries';
import { useQueryEnhanced } from 'app/hooks/useQueryEnhanced';

export const useGetPayeePromotionalCampaigns = () => {
  const canViewPromotionalCampaigns = useCanViewPayeePromotionalCampaigns();

  return useQueryEnhanced(
    [queries.payeePromotionalCampaigns],
    corePayeePromotionalCampaignClient.listPayeePromotionalCampaigns,
    {
      enabled: canViewPromotionalCampaigns,
    },
  );
};

export const useGetPayeePromotionalInvoicesByCampaign = () => {
  const canViewPromotionalCampaigns = useCanViewPayeePromotionalCampaigns();

  return useQueryEnhanced(
    [queries.payeePromotionalInvoicesByCampaign],
    corePayeePromotionalCampaignClient.listPayeePromotionalInvoices,
    {
      enabled: canViewPromotionalCampaigns,
    },
  );
};
